import * as React from 'react'

import { Text, TextName } from 'sdk'
import { OutlineGlassBackgroundCard } from 'components/outline-glass-background-card/OutlineGlassBackgroundCard'
import lightningIcon from 'shared/assets/icons/lightning-gradient.svg'

import type { ResourcesTechnologicalFirstCmsContent } from 'core/services/cms/interfaces'

import classes from './TechnologicalFirstSection.module.scss'

interface TechnologicalFirstSectionProps {
  content: ResourcesTechnologicalFirstCmsContent
}

export const TechnologicalFirstSection: React.FC<TechnologicalFirstSectionProps> = ({ content }) => {
  return (
    <div className={classes.container}>
      <Text type={TextName.H2}>{content.title}</Text>

      <div className={classes.cardsGrid}>
        {content.cards.map((card, index) => {
          const isGradientCard = index === 1

          return (
            <OutlineGlassBackgroundCard key={card.title} className={classes.card}>
              <div className={classes.cardContent}>
                <Text type={TextName.H3} className={isGradientCard ? classes.gradientText : undefined}>
                  {card.title}
                </Text>
                <div className={classes.textList}>
                  {card.items.map((item) => {
                    if (isGradientCard) {
                      return (
                        <div key={item} className={classes.textWithIcon}>
                          <img src={lightningIcon} alt='' />
                          <Text type={TextName.Text} className={classes.gradientText}>
                            {item}
                          </Text>
                        </div>
                      )
                    }

                    return (
                      <Text key={item} type={TextName.Text}>
                        {item}
                      </Text>
                    )
                  })}
                </div>
              </div>
            </OutlineGlassBackgroundCard>
          )
        })}
      </div>
    </div>
  )
}
